export default "__VITE_ASSET__DvRWBz9F__"